<template>
  <div class="build-info" v-if="buildInfo && buildInfo.buildNumber">
    {{ buildInfo.buildNumber }}
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import BuildInfo from '@/build-info';

  @Component({})
  export default class BuildNumber extends Vue {
    private buildInfo = BuildInfo;
  }
</script>

<style scoped lang="scss">
  .build-info {
    font-weight: bold;
    font-size: 0.9rem;
  }
</style>
